import { Popover } from '@material-ui/core';
import React from 'react';

// styles
import './CustomPopOverStyles.scss'

interface CustomPopOverTypes {
    anchorEl: null | Element | ((element: Element) => Element);
    manageText: string;
    handleClose?(): void;
    updateCaseStatus?(): void;
}

const CustomPopOver = (props: CustomPopOverTypes): React.ReactElement => {
    const { anchorEl, handleClose, manageText, updateCaseStatus } = props;
    const updateCase = (): void => {
        if (typeof updateCaseStatus === 'function') {
            updateCaseStatus();
        }
    }
    return (
        <Popover
            className="custom-popover"
            id="simple-popover"
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}>
            <div className="operations-popup-container">
                <div className="bubble-black" />
                <div className="operations-popup" onClick={(): void => updateCase()}>
                    {manageText}
                </div>
            </div>
        </Popover>
    );
};
export default CustomPopOver;